import clsx from 'clsx';
import React from 'react';

import styles from './DotLoader.module.scss';

const DotLoader: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <div className={clsx(styles.container, className)}>
      <div className={styles.dot} />
      <div className={styles.dot} />
      <div className={styles.dot} />
    </div>
  );
};

export default DotLoader;
